var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    d: "M8.264 4h24v40h-24Z",
    fontFamily: "none",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    d: "M10.264 6h20v4h-20zm0 6h20v4h-20zm0 6h20v4h-20z",
    fontFamily: "none",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    d: "M27.264 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fontFamily: "none",
    fill: "#76ff03"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M25.753 29.095h20v.806l-8.248 6.404a2.857 2.857 0 0 1-3.505 0l-8.247-6.404z",
    style: {
      mixBlendMode: "normal"
    },
    fontFamily: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M25.753 28.857h20v.806l-8.588 6.243a2.375 2.375 0 0 1-2.825 0l-8.587-6.243z",
    style: {
      mixBlendMode: "normal"
    },
    fontFamily: "none",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M28.179 41.838a4.502 4.502 0 0 0 6.366 0l3.317-3.317a4.502 4.502 0 0 0 0-6.366 4.502 4.502 0 0 0-6.366 0l-3.317 3.317a4.503 4.503 0 0 0 0 6.366zm1.675-4.691 3.317-3.317a2.132 2.132 0 0 1 3.016 3.015l-3.317 3.317a2.132 2.132 0 0 1-3.016-3.015z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.679 33.446s-.289-.715.365-1.483l.648-.65a4.502 4.502 0 0 0-4.703.421c-.39 1.471.177 3.1.177 3.1l1.005-1.004c.683-.682 1.675-.808 2.508-.384z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.308 33.297c-.039-.315-.084-.96.484-1.586.034-.033.436-.445.542-.55a4.36 4.36 0 0 0-3.882.27c-.402 1.221-.15 2.616 0 3.118l.72-.72a2.113 2.113 0 0 1 2.136-.532z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M43.55 26.468a4.502 4.502 0 0 0-6.367 0l-3.317 3.317a4.502 4.502 0 0 0 0 6.366 4.502 4.502 0 0 0 6.366 0l3.317-3.317a4.503 4.503 0 0 0 0-6.366zm-1.676 4.69-3.317 3.318a2.132 2.132 0 0 1-3.016-3.016l3.317-3.317a2.132 2.132 0 0 1 3.016 3.016z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.047 34.852s.29.722-.363 1.491l-.648.65a4.502 4.502 0 0 0 4.703-.422c.39-1.47-.177-3.1-.177-3.1l-1.005 1.005a2.121 2.121 0 0 1-2.51.376Z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.427 35.009c.039.314.077.96-.491 1.585l-.542.542a4.279 4.279 0 0 0 3.884-.298c.402-1.221.149-2.58-.002-3.082l-.72.72a2.136 2.136 0 0 1-2.13.533z",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M36.187 33.83a2.132 2.132 0 0 1 0 3.015l-3.317 3.317 1.676 1.676 3.317-3.317a4.502 4.502 0 0 0 0-6.366z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkService);
export default __webpack_public_path__ + "static/media/linkService.cd83f33c90973f2b8033fb7f925d7fd0.svg";
export { ForwardRef as ReactComponent };